"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = function useStyles() {
  return (0, _styles.makeStyles)(function (theme) {
    return {
      helpIconBtn: {
        padding: 0,
        transition: 'color 0.2s ease',
        color: theme.palette.PURPLE300,
        '&:hover': {
          color: theme.palette.PURPLE500
        }
      },
      helpIcon: {
        cursor: 'pointer',
        fontSize: theme.typography.pxToRem(24)
      },
      closeButton: {
        alignSelf: 'flex-end',
        padding: theme.spacing(0)
      },
      closeIcon: {
        cursor: 'pointer',
        marginLeft: 'auto',
        color: theme.palette.NEUTRAL700
      },
      helpIconActive: {
        color: theme.palette.PURPLE500
      },
      titleIcon: {
        fontSize: theme.typography.pxToRem(24),
        color: theme.palette.PURPLE300
      },
      smallIcon: {
        fontSize: theme.typography.pxToRem(20)
      },
      lightIcon: {
        color: theme.palette.NEUTRAL000
      },
      container: {
        fontFamily: theme.typography.fontFamily,
        width: '450px',
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1)
      },
      spacer: {
        margin: theme.spacing(3)
      },
      searchContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(0, 4.5)
      },
      searchField: {
        flex: 1
      },
      searchIcon: {
        color: theme.palette.NEUTRAL700
      },
      header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.typography.pxToRem(24)
      },
      title: {
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: theme.typography.pxToRem(20),
        margin: 0,
        marginLeft: theme.typography.pxToRem(10),
        flex: 1
      },
      resultsContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      },
      resultsHeader: {
        alignSelf: 'start',
        color: theme.palette.NEUTRAL300,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 600,
        margin: theme.spacing(4, 0, 1.5, 0),
        letterSpacing: theme.typography.pxToRem(0.04),
        padding: theme.spacing(0, 4.5)
      },
      resultsList: {
        padding: 0,
        margin: 0,
        maxHeight: '350px',
        overflowY: 'auto',
        overflowX: 'visible'
      },
      resultListItem: {
        listStyle: 'none'
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;